import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import EmptyListIcon from 'shared/icons/empty-list-icon'

export type InvalidInvitationLinkReason = 'canceled' | 'expired' | 'invalid' | 'mismatch'

interface InvalidInvitationLinkProps {
  reason?: InvalidInvitationLinkReason
}

export const InvalidInvitationLink = ({ reason }: InvalidInvitationLinkProps): ReactNode => {
  const { t } = useTranslation()
  return (
    <div
      data-testid="invalid-invitation-link"
      data-reason={reason}
      className="flex w-full flex-col items-center justify-center gap-3 rounded-md bg-bg-primary py-20"
    >
      <EmptyListIcon className="size-32" />
      <div className="flex flex-col items-center gap-2 px-4 text-center">
        <h1 className="text-base font-medium text-text-primary">
          {t('global.invitation.invalid_link.title')}
        </h1>
        <p className="text-sm text-text-tertiary">{t('global.invitation.invalid_link.body')}</p>
      </div>
    </div>
  )
}
